import { render, staticRenderFns } from "./ManufacturerSearchIndex.vue?vue&type=template&id=2c41e237"
import script from "./ManufacturerSearchIndex.vue?vue&type=script&lang=js"
export * from "./ManufacturerSearchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports